type SessionRejectionListener = VoidFunction;

const listeners = new Set<SessionRejectionListener>();

export const notifySessionRejected = (): void => {
  listeners.forEach(listener => listener());
};

export const subscribeToSessionRejection = (listener: SessionRejectionListener): VoidFunction => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
